import React from "react";
import { FormattedMessage } from "react-intl";

import {
  useUnsuppressAccount,
  useUnsuppressGroup,
} from "@/api/recommendations";
import { Button, HStack, Text } from "@/components/ui";

import type { Status } from "@/schemas";

interface Props {
  status: Status;
}

const SuppressedStatus = (props: Props) => {
  const { status } = props;

  const unsuppressAccount = useUnsuppressAccount();
  const unsuppressGroup = useUnsuppressGroup();

  const handleUnsuppressAccount = () => {
    if (status.group) {
      unsuppressGroup.mutate({
        statusId: status.id,
        groupId: status.group.id,
      });
    } else {
      unsuppressAccount.mutate({
        statusId: status.id,
        accountId: status.account.id,
      });
    }
  };

  return (
    <HStack
      className="p-4"
      alignItems="center"
      justifyContent="between"
      data-testid="suppressed-status"
    >
      <Text>
        {status.group ? (
          <FormattedMessage
            id="status.suppressed.group.info"
            defaultMessage="We'll no longer suggest content from this group."
          />
        ) : (
          <FormattedMessage
            id="status.suppressed.status.info"
            defaultMessage="We'll no longer suggest content from this profile."
          />
        )}
      </Text>

      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={handleUnsuppressAccount}
      >
        <FormattedMessage id="common.undo" defaultMessage="Undo" />
      </Button>
    </HStack>
  );
};

export default SuppressedStatus;
